// extracted by mini-css-extract-plugin
module.exports = {"button":"NavigationToggle-module--button--1xyy0","icon":"NavigationToggle-module--icon--DysYJ","icon__close":"NavigationToggle-module--icon__close--t09sH"};